<template>
  <b-dropdown
    variant="link"
    toggle-class="p-0 border-0"
    menu-class="overflow-menu"
    :lazy="true"
    :dropright="dropright"
    boundary="viewport"
    no-caret
  >
    <template slot="button-content">
      <slot />
    </template>
    <b-dropdown-item v-for="option in options" :key="option.id" @click="$emit('change', option)">{{
      option.label
    }}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

/**
 * This component renders dropdown. Dropdown field it customizable, which can be passed as default slot.
 */
export default {
  name: 'StyledFieldDropdown',
  props: ['options', 'dropright'],
  components: {
    BDropdown,
    BDropdownItem
  }
}
</script>

<style lang="scss" scoped></style>
